export default "__VITE_ASSET__22b7ddb3__"